import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const PreferredConditions = (props: any) => {
  return (
    <SvgIcon
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      id="f4ae9fc7-39b4-4a0c-ab0d-1a18a160cb1c"
      data-name="Layer 1"
      viewBox="0 0 200 200"
    >
      <rect width="120" height="40" />
      <rect x="160" width="40" height="40" />
      <rect x="80" y="160" width="120" height="40" />
      <rect y="160" width="40" height="40" />
      <rect y="80" width="80" height="40" />
      <rect x="120" y="80" width="40" height="40" />
    </SvgIcon>
  );
};

export default PreferredConditions;
